import { render, staticRenderFns } from "./BirthdaysList.vue?vue&type=template&id=18576f29"
import script from "./BirthdaysList.vue?vue&type=script&lang=js"
export * from "./BirthdaysList.vue?vue&type=script&lang=js"
import style0 from "./BirthdaysList.vue?vue&type=style&index=0&id=18576f29&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports